//Generated File 
export const FIELDS_SELECTOR_POPUP = `fieldsSelectorPopup`;
export const LAYOUT_EDITOR_VIEW = `layouteditor`;
export const PAIR_SEPERATOR = `/`;
export const PARAMETERS_SEPERATOR = `&`;
export const PREFIX_APPROVALS = `approvals`;
export const PREFIX_CONFIGURATION = `configuration`;
export const PREFIX_EDIT = `edit`;
export const PREFIX_EDIT_FILE = `editfile`;
export const PREFIX_EDIT_LAYOUT = `layoutedit`;
export const PREFIX_ENTITY_CONFIG = `entityconfig`;
export const PREFIX_Email = `emails`;
export const PREFIX_LAUNCH_REPORT = `rpt`;
export const PREFIX_LIST = `list`;
export const PREFIX_REPORT_List = `rptlst`;
export const PREFIX_REPORT_Result = `rptres`;
export const PREFIX_WELCOME = ``;
export const PREFIX_login = `login`;
export const PREFIX_notifications = `notifications`;
export const PREFIX_sql = `sql`;
export const PREFIX_userloginhistory = `userloginhistory`;
export const PRM_ASCENDING = `asc`;
export const PRM_CRITERIA = `criteria`;
export const PRM_DASHBOARDID = `dsh`;
export const PRM_DATA_SOURCE_1 = `dataSource1`;
export const PRM_DATA_SOURCE_2 = `dataSource2`;
export const PRM_DATA_SOURCE_3 = `dataSource3`;
export const PRM_DATA_SOURCE_4 = `dataSource4`;
export const PRM_DATA_SOURCE_5 = `dataSource5`;
export const PRM_DEBUG = `dbg`;
export const PRM_DOWNLOAD_PURPOSE = `dwnldprp`;
export const PRM_EDIT_TEMPLATE_ID = `tmplt`;
export const PRM_EDIT_VIEW_NAME = `eview`;
export const PRM_ENTITYID = `eid`;
export const PRM_ENTITY_TYPE = `entity`;
export const PRM_EXTRA_CRITERIA = `extrcrt`;
export const PRM_EXTRA_FIELD_FILTER = `extrfltr`;
export const PRM_FIELDS = `fields`;
export const PRM_FIELD_TITLE = `fieldTitle`;
export const PRM_FLOW_ID = `flowid`;
export const PRM_FLOW_TARGET_ID = `flowttargetid`;
export const PRM_FLOW_TARGET_TYPE = `flowtargettype`;
export const PRM_FOCUS_ON_FIELD = `focusOnField`;
export const PRM_FORM_REPORT_ID = `formReportId`;
export const PRM_FOR_MOBILE_VIEW = `forMobileView`;
export const PRM_FOR_QUICK_CREATOR_VIEW = `forQuickCreatorView`;
export const PRM_ID = `id`;
export const PRM_IMPORT_OBJECTS = `importObjects`;
export const PRM_IS_FORM = `isForm`;
export const PRM_IS_FROM_REPORTING_ENTITY = `isFromReportingEntity`;
export const PRM_LANGUAGE = `lang`;
export const PRM_LIST_VIEW_NAME = `lview`;
export const PRM_LOGOUT = `logout`;
export const PRM_MENU_HASH = `menu`;
export const PRM_MONIOR_ID = `mntr`;
export const PRM_NESTING = `nesting`;
export const PRM_OUTPUT_FORMAT = `frmt`;
export const PRM_OWNER_ID = `ownerid`;
export const PRM_OWNER_TYPE = `ownertype`;
export const PRM_PAGE = `page`;
export const PRM_PAGE_ID = `pgid`;
export const PRM_PAGE_SIZE = `pageSize`;
export const PRM_PENDING_RESPONSE_ID = `pendingResponseId`;
export const PRM_PRINTER_NAME = `prntrname`;
export const PRM_PRINTING_OPTION = `prntopt`;
export const PRM_QUESTIONS = `questions`;
export const PRM_QUICKCREATE = `quick`;
export const PRM_QUICKCREATE_REQUESTER = `quickreq`;
export const PRM_REDIRECT = `redirect`;
export const PRM_REPLICATION_OPTIONS = `repl`;
export const PRM_REPORT_WIZARD_ID = `reportWizardId`;
export const PRM_RESET_TOKEN = `rsttkn`;
export const PRM_RESET_USER = `rstusr`;
export const PRM_ROOT = `root`;
export const PRM_ROOT_TYPE = `rootType`;
export const PRM_SCREEN_TYPE = `screenType`;
export const PRM_SERVEROBJECT = `srvrobj`;
export const PRM_SHOW_IDS = `showids`;
export const PRM_SHOW_TREE = `tree`;
export const PRM_SORT_BY = `sort`;
export const PRM_TAB_ID = `tabid`;
export const PRM_TEMP_PRINT_ID = `tmpprnt`;
export const PRM_VERSION = `version`;
export const PRM_VIEW = `view`;
export const REPORT_EXPRESSION_EDITOR = `reportExpressionEditor`;
export const REPORT_UNION_HANDLING_EDITOR = `reportUnionHandlingEditor`;
export const REPORT_WIZARD_EDITOR = `reportWizardEditor`;
export const WIZARD_VIEW = `wizard`;
